import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumbs-path',
  templateUrl: './breadcrumbs-path.component.html'
})
export class BreadcrumbsPathComponent implements OnInit {

  constructor() { }

  @Input() crumbData: any = [];
  ngOnInit(): void {
  }

}
